"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldSanitise = exports.sanitizeData = exports.KEY_BLACKLIST_MATCH = exports.KEY_WHITELIST_PREFIX = void 0;
const _ = require("lodash");
exports.KEY_WHITELIST_PREFIX = 'piiAllowed';
exports.KEY_BLACKLIST_MATCH = _.map([
    'lastName',
    'last_name',
    'phoneNumber',
    'phone_number',
    'email',
    'phone',
], _.toLower);
function sanitizeData(logger, data, valueSuffix) {
    try {
        if (Array.isArray(data)) {
            return data.map(item => sanitizeData(logger, item, valueSuffix));
        }
        if (typeof data !== 'object') {
            return shouldSanitise({ value: data, key: undefined }) ? null : data;
        }
        const sanitizeObj = {};
        _.forIn(data, (value, key) => {
            if (typeof value === 'object') {
                sanitizeObj[key] = sanitizeData(logger, value, valueSuffix);
            }
            else if (shouldSanitise({ key, value })) {
                sanitizeObj[key] = null;
                sanitizeObj[`${key}_sanitised`] = `${Date.now()}${valueSuffix ? `_${valueSuffix}` : ''}`;
            }
            else {
                sanitizeObj[key] = value;
            }
        });
        return sanitizeObj;
    }
    catch (error) {
        logger.error('Failed to sanitise event', { valueSuffix, error });
        return data;
    }
}
exports.sanitizeData = sanitizeData;
function shouldSanitise({ key, value }) {
    if (_.startsWith(key, exports.KEY_WHITELIST_PREFIX)) {
        return false;
    }
    const forbiddenValueRegexes = [
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        /^(?:\+?972|0|972)(?:(?:[23489]|5\d)\d{7})$/,
        /^(?:(?:\+44)|(?:0))(?:(?:\d{4}\s?\d{6})|(?:\d{3}\s?\d{3}\s?\d{4})|(?:\d{5}\s?\d{5})|(?:\d{10}))$/, // UK Phone
    ];
    return (key && key.toLowerCase().includes('piivalue'))
        || (key && _.includes(exports.KEY_BLACKLIST_MATCH, _.toLower(key)))
        || forbiddenValueRegexes.some(regex => regex.test(value));
}
exports.shouldSanitise = shouldSanitise;
